import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 0',
        alignItems: 'flex-start',
        gap: '15px'
    },
    name: {
        fontSize: '16px',
        fontWeight: '600',
        '.lightTheme &': {
            color: '#222'
        }
    },
    btn: {
        textTransform: 'initial'
    },
    divider: {
        width: '100%'
    },
    tasks:{
        card:{
            backgroundColor:'transparent!important'
        }
    }
}